import BasePreloadScreenMediator from "../../../../../shared/src/ranj/equalture/view/BasePreloadScreenMediator.js";

export default class PreloadScreenMediator extends BasePreloadScreenMediator {

    constructor(target, dispatcher, layoutManager, soundManager, startup, config) {
        super(target, dispatcher, layoutManager, soundManager, startup, config);
    }
}
